import React, { useState, createContext, useEffect, useRef } from "react";
import translate from "./translate";
import backgroundBubble0L from "../imgs/background0l.png";
import backgroundBubble0R from "../imgs/background0r.png";
import getServicesApi from "../apis/servicesApi";
import getServices2Api from "../apis/services2Api";
import getPackagesApi from "../apis/packagesApi";
import getPartnersApi from "../apis/partnersApi";
import getSiteInfoApi from "../apis/siteInfoApi";
import getExperiencesApi from "../apis/experiencesApi";
export let Context = createContext(0);
const ContextProvider = (props) => {
  const { dir, setDir, lang } = props;
  const [isClicked, setIsClicked] = useState(false);
  const [isHovering, setIsHovering] = useState(false);
  const [clickbtns, setClickbtns] = useState("");

  const [servicesRes, setServicesRes] = useState([]);
  const [servicesResdata, setServicesResdata] = useState([]);
  const [servicesResLoading, setServicesLoading] = useState(false);

  const [services2Res, setServices2Res] = useState([]);
  const [services2ResData, setServices2ResData] = useState([]);
  const [servicesRes2Loading, setServices2Loading] = useState(true);

  const [packagesRes, setPackagesRes] = useState([]);
  const [packagesResData, setPackagesResData] = useState([]);
  const [packagesLoading, setPackagesLoading] = useState(false);

  const [partnersRes, setPartnersRes] = useState([]);
  const [partnersResData, setPartnersResData] = useState([]);
  const [partnersLoading, setPartnersLoading] = useState(false);

  const [experiencesRes, setExperiencesRes] = useState([]);
  const [experiencesResData, setExperiencesResData] = useState([]);
  const [experiencesLoading, setExperiencesLoading] = useState(false);

  const [siteInfoRes, setSiteInfoRes] = useState([]);
  const [siteInfoLoading, setSiteInfoLoading] = useState(false);

  const homeSection = useRef(null);
  const servicesSection = useRef(null);
  const partnersSection = useRef(null);
  const packagesSection = useRef(null);
  const startSection = useRef(null);
  const contactSection = useRef(null);
  const baseURL = "https://mycash-dashbackend.fatoorah.online/apiAdmin";
  /////////////////useEffect///////////////
  useEffect(() => {
    getServicesApi(
      setServicesRes,
      setServicesResdata,
      lang,
      baseURL,
      setServicesLoading
    );
    getServices2Api(
      setServices2Res,
      setServices2ResData,
      lang,
      baseURL,
      setServices2Loading
    );
    getPackagesApi(
      setPackagesRes,
      setPackagesResData,
      lang,
      baseURL,
      setPackagesLoading
    );
    getPartnersApi(
      setPartnersRes,
      setPartnersResData,
      lang,
      baseURL,
      setPartnersLoading
    );
    getExperiencesApi(
      setExperiencesRes,
      setExperiencesResData,
      lang,
      baseURL,
      setExperiencesLoading
    );
    getSiteInfoApi(setSiteInfoRes, lang, baseURL, setSiteInfoLoading);
  }, [lang]);

  ///////////////////////////////
  const scrollToSection = async (elementRef) => {
    if (elementRef.current && window.innerWidth > 993) {
      window.scrollTo({
        top: elementRef.current.offsetTop - 96, /// 96 = navbar height
        behavior: "smooth",
      });
      setIsClicked(false);
      setIsHovering(false);
    }
    if (elementRef.current && window.innerWidth <= 993) {
      window.scrollTo({
        top: elementRef.current.offsetTop - 72, /// 72 = navbar height
        behavior: "smooth",
      });
      setIsClicked(false);
      setIsHovering(false);
    } else {
      await new Promise((resolve) => setTimeout(resolve, 250));
      window.scrollTo({
        top: elementRef.current.offsetTop - 96, /// 96 = navbar height
        behavior: "smooth",
      });
    }
  };

  ////////////////////////////////
  const handleClick = () => {
    // for navBar mobile handleClick OR
    if (isClicked) {
      setIsClicked(false);
    } else {
      setIsClicked(true);
    }
  };
  const handleHover = () => {
    // for footer hover handleClick OR
    if (isHovering) {
      setIsHovering(false);
    } else {
      setIsHovering(true);
    }
  };
  //////////////////////////////////
  const handelDirection = () => {
    if (dir === "ltr") {
      setDir("rtl");
      localStorage.setItem("dir", "rtl");
      document.body.style.direction = "rtl";
    } else {
      setDir("ltr");
      localStorage.setItem("dir", "ltr");
      document.body.style.direction = "ltr";
    }
  };
  ////////////////////////////////////
  const clickBtn = async (btn, time) => {
    setClickbtns(btn);
    await new Promise((resolve) => setTimeout(resolve, time));
    setClickbtns("");
  };

  /////////////////////////////////
  const variants0 = {
    active: {
      width: 342,
      transition: {
        duration: 0.5,
        ease: "easeInOut",
        type: "spring",
        mass: 2,
        stiffness: 400,
        damping: 40,
      },
    },
    inactive: {
      width: 140,
      transition: {
        duration: 0.5,
        ease: "easeInOut",
        type: "spring",
        mass: 2,
        stiffness: 400,
        damping: 40,
      },
    },
  };
  const variants1 = {
    showComponets: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeInOut",
      },
    },
    showTables: {
      opacity: 1,
      transition: {
        duration: 0.4,
        ease: "easeInOut",
      },
    },
    hidden: {
      opacity: 0,
    },
    visible: {
      opacity: 1,
      transition: {
        delay: 0.18,
        duration: 0.15,
        ease: "easeInOut",
      },
    },
    exit: {
      opacity: 0,
      transition: {
        duration: 0.1,
        ease: "easeInOut",
      },
    },
  };
  const variants3 = {
    active: {
      translateX: 1,
      transition: {
        duration: 0.5,
        ease: "easeInOut",
        type: "spring",
        mass: 3,
        stiffness: 600,
        damping: 30,
      },
    },
    inactive: {
      translateX: 1,
      transition: {
        duration: 0.5,
        ease: "easeInOut",
        type: "spring",
        mass: 3,
        stiffness: 600,
        damping: 30,
      },
    },
  };
  const variants4 = {
    active: {
      display: "block",
      opacity: 1,
      height: "auto",
      transition: {
        duration: 1,
        ease: "easeInOut",
        type: "spring",
        mass: 2,
        stiffness: 400,
        damping: 40,
      },
    },
    inactive: {
      transitionEnd: {
        display: "none",
      },
      opacity: 0,
      height: 0,
      transition: {
        duration: 0.5,
        ease: "easeInOut",
        type: "spring",
        mass: 2,
        stiffness: 400,
        damping: 40,
      },
    },
  };
  /////////////////////////////////////

  return (
    <Context.Provider
      value={{
        dir,
        translate,
        setIsClicked,
        isClicked,
        handleClick,
        handleHover,
        isHovering,
        setIsHovering,
        handelDirection,
        backgroundBubble0L,
        backgroundBubble0R,
        scrollToSection,
        homeSection,
        servicesSection,
        partnersSection,
        packagesSection,
        startSection,
        contactSection,
        variants0,
        variants1,
        variants3,
        variants4,
        clickBtn,
        clickbtns,
        baseURL,
        lang,
        servicesRes,
        servicesResdata,
        servicesResLoading,
        services2Res,
        services2ResData,
        servicesRes2Loading,
        packagesRes,
        packagesResData,
        packagesLoading,
        partnersRes,
        partnersResData,
        partnersLoading,
        experiencesRes,
        experiencesResData,
        experiencesLoading,
        siteInfoRes,
        siteInfoLoading,
      }}
    >
      {props.children}
    </Context.Provider>
  );
};
export default ContextProvider;
